// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1l9SJ","large":"styles_large__1MhnP"};